var runtime = require("../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"option":"OkZ_C","options":"_13GUz"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .OkZ_C,"+wrap+" ._13GUz{width:100%}"+wrap+" .OkZ_C{display:block;overflow:hidden;text-overflow:ellipsis}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

